import { Paper, Skeleton, Stack, Group } from "@mantine/core";

interface PatientListSkeletonProps {
  count?: number;
  showDataIndicators?: boolean;
}

export function PatientListSkeleton({
  count = 5,
  showDataIndicators = true,
}: PatientListSkeletonProps) {
  return (
    <Stack gap="xs">
      {Array.from({ length: count }).map((_, index) => (
        <Paper key={index} p="sm" withBorder>
          <Group justify="space-between" align="flex-start">
            <div style={{ flex: 1 }}>
              <Group gap="xs" mb="xs">
                <Skeleton height={20} width={120} />
                <Skeleton height={16} width={80} />
                <Skeleton height={20} width={60} />
              </Group>

              <Group gap="md" mb="xs">
                <Skeleton height={14} width={60} />
                <Skeleton height={14} width={80} />
              </Group>

              {showDataIndicators && (
                <Group gap="xs" mt="xs">
                  <Skeleton height={20} width={40} />
                  <Skeleton height={20} width={40} />
                  <Skeleton height={20} width={40} />
                  <Skeleton height={20} width={40} />
                  <Skeleton height={20} width={50} />
                </Group>
              )}
            </div>

            <Skeleton height={24} width={60} />
          </Group>
        </Paper>
      ))}
    </Stack>
  );
}
